export class DataService {
    constructor() {
        this.tokenCheckUrl = "adminapi.php?a=tokenCheck";
        this.authenticateUrl = "adminapi.php?a=authenticate";
        this.sectionDataUrl = "adminapi.php?a=getallsectiondata";
        this.oneSectionDataUrl = "adminapi.php?a=getOneSection";
        this.quizScoresDataUrl = "adminapi.php?a=getQuizScores";
    }

    post (url, data, headers, callBackSuccess, callBackFailed) {
		fetch(url, {
			headers: headers,
			method: "POST",
			body: JSON.stringify(data)
		})
		.then((promise) => {
				promise.json()
				.then((res)=>{
					callBackSuccess(res);
				})
				.catch((err)=>{
					console.log(err);
					callBackFailed(err);
				});
		})
		.catch((err) => {
			callBackFailed(err);
		});
    }
    
    postData(url, data, callBackSuccess, callBackFailed) {
		var headers = {
		  'Accept': 'application/json',
		  'Content-Type': 'application/json'
		};
		this.post(url, data, headers, callBackSuccess, callBackFailed);
    }

    authenticate(data, callBackSuccess, callBackFailed){
        this.postData(this.authenticateUrl, data, callBackSuccess, callBackFailed);
    }
    
    tokenCheck(callBackSuccess, callBackFailed) {
		try
		{
			var token = localStorage.getItem("token");
			this.postData(this.tokenCheckUrl, {token:token},
				function(response) {
					if (response.status == "ok") {
						callBackSuccess();
					} else {
						callBackFailed();
					}
				},
				function(err) {
					console.log(err);
				}
			);
		}
		catch (err) {
			callBackFailed(err);
		}
    }
    
    getAllLogs(callBackSuccess, callBackFailed) {
		const token = localStorage.getItem("token");
		this.postData(this.sectionDataUrl, {token:token}, callBackSuccess, callBackFailed);
    }

    getSection(section, callBackSuccess, callBackFailed) {
		const token = localStorage.getItem("token");
		this.postData(this.oneSectionDataUrl, {token:token, section:section}, callBackSuccess, callBackFailed);
    }
    
    getQuizScores(section, yearMonth, monthYear, callBackSuccess, callBackFailed) {
		const token = localStorage.getItem("token");
		this.postData(this.quizScoresDataUrl, {token:token, section:section, yearMonth:yearMonth, monthYear:monthYear}, callBackSuccess, callBackFailed);
    }
    
    clearData(){
        localStorage.clear();
    }
}
setTimeout(function(){_svc.data = new DataService()},1);